import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/login';
import routers from './routers';

function App() {
  return (
    <div>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {routers.map((route, index) => {
            const Element = route.element;
            const roleTarget = route.roleTarget;
            return (
              <Route
                key={index}
                path={route.path}
                element={<Element/>}
                // element={
                //   <PrivateRoute>
                //     <Element/>
                //   </PrivateRoute>
                // }
              />
            );
          })}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
    </div>
  );
}

export default App;
